import { Link } from "react-router-dom";
import { InformationCircleIcon } from "@heroicons/react/outline";

import { CollectorConfig } from "providers/HostedScrapingProvider/types";
import { LinkText } from "components/LinkText";
import { LegacyRateCallout } from "components/LegacyRateCallout";
import { BillingPath } from "v2/pages/billing/BillingPath";
import { useUser } from "routes/dataroutes/UserData";
import { AmazonProjectDetails, CostRow, EbayProjectDetails, GoogleProjectDetails, Separator, SummaryRow, UrlProjectDetails, WalmartProjectDetails, RedfinProjectDetails, HomeDepotProjectDetails, HomeDepotProductProjectDetails, HomeDepotReviewsProjectDetails, textsAP } from "./ProjectSummaryComponents";
import { isAmazonProject, isAsyncUrlsProject, isEbayProject, isGoogleProject, isWalmartProject, isRedfinProject, isHomeDepotSearchProject, isHomeDepotProductProject, isHomeDepotReviewsProject, isAsyncUrlsLlmProject } from "sdecontent";


const calculateRunPerMonth = (inProgress: boolean, creditsLeft: number, cost: number | undefined): string | number=> {
  if (inProgress || cost === undefined || cost === 0) {
    return '?'
  } else {
    return Math.floor((creditsLeft) / cost);
  }
}

export type IProjectsummarysidebarProps = {
  details: { title: string, value: string }[];
  cost: number | undefined;
  costInProgress: boolean;
  config: CollectorConfig;
  /** Standard price to warn about when the account is on a legacy rate for this domain (ENG-1112). */
  legacyStandardCredits?: number;
};

export const ProjectSummarySidebarApiPlayground = ({details, config, cost, costInProgress, legacyStandardCredits} : IProjectsummarysidebarProps) => {
  const user = useUser();
  const creditsLeft = user ? user.creditsRemaining : 0;
  const runsLeft = calculateRunPerMonth(costInProgress, creditsLeft, cost);
  const pluralS = runsLeft === 1 ? '' : 's';

  const texts = textsAP;

  return (
    <div className="p-6 h-full bg-lightestGray dark:bg-neutral-50 text-gray dark:text-neutral-600">
      <div className="text-2xl pb-6">SUMMARY</div>

      {details.map(
        ({title, value}) => <SummaryRow key={value} title={title} value={value} />
      )}

      <Separator />

      <div className="pb-4">OPTIONS & FILTERS</div>
      { isAsyncUrlsProject(config.type)
        && <UrlProjectDetails collectorConfig={config} />}
      { isAsyncUrlsLlmProject(config.type)
        && <UrlProjectDetails collectorConfig={config} />}
      { isAmazonProject(config.type)
        && <AmazonProjectDetails collectorConfig={config} />}
      { isGoogleProject(config.type)
        && <GoogleProjectDetails collectorConfig={config} />}
      { isWalmartProject(config.type)
        && <WalmartProjectDetails collectorConfig={config} />}
      { isEbayProject(config.type)
        && <EbayProjectDetails collectorConfig={config} />}
      { isRedfinProject(config.type)
        && <RedfinProjectDetails collectorConfig={config} />}
      { isHomeDepotSearchProject(config.type)
        && <HomeDepotProjectDetails collectorConfig={config} />}
      { isHomeDepotProductProject(config.type)
        && <HomeDepotProductProjectDetails collectorConfig={config} />}
      { isHomeDepotReviewsProject(config.type)
        && <HomeDepotReviewsProjectDetails collectorConfig={config} />}

      <Separator />

      <CostRow texts={texts} cost={cost} costInProgress={costInProgress} />
      {!costInProgress && <LegacyRateCallout standardCredits={legacyStandardCredits} className="mt-2" />}

      <Separator />

      <div className="flex flex-row gap-2">
        <div className="flex-shrink-0 w-5 h-5 text-brandPrimary dark:text-primary-600"><InformationCircleIcon /></div>
        <div className="flex-shrink">
          <p className="mb-5">{texts.content(creditsLeft, runsLeft, pluralS)}</p>
          <p>Need more credits? <Link to={ BillingPath }><LinkText>Upgrade plan</LinkText></Link></p>
        </div>
      </div>

    </div>
  )
}
